import { IMapperTable, IMapperConnectionInfo } from 'app/model/adfDataMapper/IMapperTable';
import { MapperConnection } from 'app/model/adfDataMapper/mapperConnection';
import { IModel, Metamodel, Named } from 'shell-models-lib';

@Metamodel.model({
    name: 'MappingSourceConnectionInfo'
})
export class MappingSourceConnectionInfo extends Named implements IMapperConnectionInfo {
    public static readonly MODEL: IModel;
    public connection: MapperConnection;

    public tables: IMapperTable[] = [];
    constructor(connection?: MapperConnection, tables?: IMapperTable[]){
        super();
        this.connection = connection;
        this.tables = !!tables ? tables : [];
    }
}
